import React, {type ReactElement} from "react";
import styles from "./SpinnerBorder.module.sass";

export default function SpinnerBorder(): ReactElement {
    return (
        <div className={styles.spinner}/>
    )
}